
// profile/getters.ts
import {GetterTree} from 'vuex';
import {RootState} from '../types';
import {MAFUser} from '@/store/User/types';
import {
    FriendState,
    message,
    MessagePrompt,
    UserWithMessage,
    WebRTCRequest,
    WebRTCRequestState,
} from '@/store/Friends/types';
import * as _ from 'lodash';

export const getters: GetterTree<FriendState, RootState> = {
  getChatPrompt(state: FriendState): (type: string) => (MessagePrompt[] ) {
    return (type: string) => {
      // @ts-ignore
      return state && state.chatPrompts && state.chatPrompts[type] ? state.chatPrompts[type] : [];
    };
  },

  getFriends(state): MAFUser[] |  undefined {
    return state.friends;
  },

  getMessages(state): UserWithMessage[] | undefined {
    return state.messages;
  },

  getFriendMessages(state: FriendState, messageGetters: any): (friendId: string) => (message[] ) {
    return (friendId: string) => {
      const UserWith: any = _.find(state.messages, (mes: UserWithMessage) => {
        return mes.user.uid === friendId;
      });
      if (UserWith) {
        return UserWith.messages;
      }
      return [];
    };
  },

  getFriendsAndMessages(state: FriendState, messageGetters: any): UserWithMessage[] {
    return state.messages ? state.messages : [];
  },

  // queue of connection requests from friends
  queueConnectionRequests(state: FriendState): MAFUser | null {
    return (state.connectionRequests && state.connectionRequests.length) ? state.connectionRequests[0] : null;
  },

  // latest video connection actually established
  getLatestConnection(state: FriendState): WebRTCRequest | null {
    return state.connections && state.connections.length ? state.connections[0] : null;
  },
};
